<template>
  <div class="req-success">
    <Modal
      v-model:show="active"
      class="offer__request"
    >
      <template v-slot:header>
        <h5 class="modal-title mt-8">
          {{ $t('offer.offerRequestSuccess.title') }}
        </h5>
      </template>
      
      <div class="!tw-text-center pt-30 pb-30">
        <div class="request-img-wr ">
          <img
            :src="okImg"
            class="request-img"
            alt="exclamation"
          >
          <br>
          <br>
        </div>
        <br>
        <span>{{ $t('offer.offerRequestSuccess.text') }}.</span>
      </div>

      <template v-slot:footer>
        <div class="!tw-text-center btn-wrap">
          <button
            class="btn btn-primary btn-sm mr-10 mt-8 mb-4 req-btn-c"
            @click="active = false"
          >
            {{ $t('offer.offerRequestSuccess.btn') }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { Modal } from '@/components';
import okImg from '@/assets/theme/icon/ok.svg';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    okImg: () => okImg,
  },
  methods: {
    open() {
      this.active = true;
    },
  },
};
</script>

<style lang="scss">
.req-success{
	.modal-dialog{
		max-width: 350px !important;
	}
	.btn-wrap{
		display: flex;
		width: 100%;

		justify-content: center;
	}
	.req-btn-c{
		min-width: 190px !important;
	}
	@media (min-width: 576px){
		.modal-dialog{
			max-width: 350px !important;
		}
	}
}
</style>
